import {useEffect, useState} from "react";
import Strings from "../Lang/strings";

const useTimer = (timerRef) => {
    const [timerOver, setTimerOver] = useState(false);

    useEffect(() => {
        let timeLeft = 15;
        window.timerId = setInterval(countdown, 1000);

        function countdown() {
            if (timeLeft === 0) {
                clearTimeout(window.timerId);
                timerRef.current.innerHTML = "";
                setTimerOver(true);
            } else {
                timerRef.current.innerHTML = timeLeft + " " + Strings.canUpdateAfterCountdownSeconds;
                timeLeft--;
            }
        }

    }, []);

    return timerOver;
}


export default useTimer;